import React from "react";
import { Box, Button } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { Invoice } from "@rentablo/api/apiv1";
import GetAppIcon from "@icons/myicons/download.svg?react";

const DownloadWrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down("md")} {
    border-style: solid;
    border-width: 0;
    border-color: ${({ theme }) => theme.palette.border.secondary};
    padding-bottom: ${({ theme }) => theme.spacing(3)};
    border-bottom-width: 1px;
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 14px;
    font-weight: 600;
  }
`;

const BaseStatusItem = styled(Box)`
  padding: ${({ theme }) => theme.spacing(1, 2)};
  border-radius: 4px;
  display: flex;
  align-items: center;
`;

const Incomplete = styled(BaseStatusItem)`
  cursor: unset;
  background: ${({ theme }) => theme.palette.background.upgrade};
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export interface DownloadControlProps {
  handleDownload: (id: number, filename: string) => void;
  invoice: Invoice;
}

export const DownloadControl = (props: DownloadControlProps) => {
  const { invoice, handleDownload } = props;
  const { t } = useTranslation();

  const downloadInvoice = () => {
    const datesString = [
      invoice.billingCycleStartDate,
      invoice.billingCycleEndDate,
    ]
      .filter(Boolean)
      .map((date) => format(new Date(date!), "dd_MM_yyyy"))
      .join("__");

    return handleDownload(
      invoice.billingCycleId!,
      `Rechnung${datesString ? "_" : ""}${datesString}`
    );
  };

  return (
    <DownloadWrapper>
      {invoice?.billingCycleId && (
        <StyledButton
          size="small"
          variant="text"
          color="primary"
          startIcon={<GetAppIcon />}
          onClick={downloadInvoice}
        >
          {t("domains.cashback.dashboard.summary.download")}
        </StyledButton>
      )}
      {!invoice?.billingCycleId && (
        <>
          <Incomplete>
            {t("domains.cashback.dashboard.summary.incomplete")}
          </Incomplete>
        </>
      )}
    </DownloadWrapper>
  );
};
